import React from 'react';

//components
import ProjectCard from './ProjectsCard'
import PromptCard from './PromptCard'
import TemplateCard from './TemplateCard';
import ElaborationCard from './ElaborationCard';
import KBCard from './KBCard';

const Dashboard = () => {

    return (
        <div className="appPage">
            <div className="appPage__pageHeader">
                <h1>Dashboard</h1>
                <div className='dashboard_CardsContainer'>
                    <ProjectCard/>
                    <PromptCard/>
                    <TemplateCard/>
                    <ElaborationCard/>
                    <KBCard/>
                </div>
            </div>

            <div className="appPage__spacer"></div>
        </div>
    )
}

export default Dashboard;